const authEn = {
    "sign_in": "Sign in",
    "email": "Email Address",
    "password": "Password",
    "sign_in_button": "Sign In",
    "invalid_credentials": "Invalid credentials",
    "password_min_length": "The password must be at least 8 characters long",
    "passwords_do_not_match": "Passwords do not match",
    "invalid_token": "Invalid token",
    "password_set": "Password set",
    "confirm_password": "Confirm password",
    "confirm_title": "Quickpick Admin Registration Confirmation",
    "confirm_text": "To set up your account, you just need to provide a secure password",
    "set_password": "Set Password",
    "account_activated": "Account activated",
    "account_activated_text": "You can now log in to your user account with your provided email address and password",
    "continue_to_login": "Continue to login",
    "forgotten_password": "Forgotten password",
    "unable_to_reset_password": "Internal error, unable to reset password.",
    "reset_password_title": "Reset password",
    "reset_password_text": "Please enter the email address used for with your account. We will send the link to reset the password to the email address.",
    "send_reset_mail": "Send password reset link",
    "send_reset_mail_success": "An email has been sent to the provided address with further instructions",
    "invalid_email": "Invalid email address",
    "reset_sent": "Email sent",
    "change_password_title": "Change password",
    "change_password_success": "Password changed successfully",
    "roles": {
        "OWNER": "Admin",
        "MENU_EDITOR": "Menu editing",
        "STAFF_MANAGER": "Staff management"
    },
    "name": "Name",
    "permissions": "Permissions",
    "create_user_permissions": "Create user permissions",
    "add_restaurant": "Add restaurant",
    "user_saved": "User saved",
    "has_admin_permissions": "Admin permissions",
    "login_with_google": "Login with Google",
    "missing_perrmissions": "You do not have the required permissions to access this page",
    "qp_signup_title": "QuickPick Registration",
    "qp_signup_text": "Fill out the fields below to create a user account!",
    "user_information": "User information",
    "restaurant_information": "Restaurant information",
    "restaurant_shortname": "Restaurant identifier",
    "restaurant_name": "Restaurant name",
    "create_profile": "Create",
    "restaurant_name_short": "Restaurant name must be at least 3 characters long",
    "identifier_example": "Example identifier",
    "invalid_shortname": "Restaurant identifier must be at least 3 characters long",
    "restaurant_shortname_already_in_use": "Restaurant identifier already in use",
    "name_missing": "Name is missing",
    "signup_failed": "Registration failed. Please try again later.",
    "no_restaurant_title": "No restaurant selected for your account",
    "no_restaurant_text": "If you just finished created your account, you should also register your restaurant!",
    "no_restaurant_alt": "If you were supposed to receive access to a restaurant, please contact the restaurant's administrator.",
    "no_user_created_yet": "Don't have an account yet?",
    "signup_success": "Registration successful",
    "grant_admin_title": "Grant admin permissions",
    "grant_admin_confirmation": "User with admin permissions can manage the restaurant settings, add and remove users, manage subscriptions, payments and invoices. Editing the menu does not require admin permissions.",
    "selected_user": "Selected user",
    "delete_user_title": "Remove user",
    "delete_user_confirmation": "The selected user will be removed from the restaurant and have no access to its menu anymore. This action cannot be undone.",
    "admin": "Admin",
    "activate_account": "Activate account",
    "account_pending_activation": "Your user account is pending activation.",
    "check_your_activate_email": "Please check your email inbox and click the activation link",
    "refresh_page": "Refresh page",
    "did_not_receive_activation_email": "I did not receive the activation email",
    "activate_tip": "If you can't find the activation email, check your spam folder as well. If it's not there, click the button below to resend it.",
    "resend_email": "Resend",
    "email_resent": "The activation email has been resent successfully. Please check your email inbox.",
    "accept_terms_and_conditions": "I read and accept the <a>Terms and Conditions and Privacy Policy</a>",
    "complete_registration": "Complete Registration",
    "auth_in_progress": "Authentication in progress...",
    "account_successfully_activated": "Your QuickPick account has been successfully activated",
    "continue_to_home_page": "Continue to Home Page",
    "invalid_activation": "An error occurred while activating the account. Please try again later or contact our customer support.",
    "activation_mail_sent": "We have started creating your account. Please check your email inbox and finalize the registration by clicking the link in the email."

}

export default authEn;